module.exports = __webpack_public_path__ + "static/logo-dbj-92b55895c38884befec1f80ddc791717.png";